// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/market-rates/market-rates.component.scss
// module id = 411
// module chunks = 0